
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export const OrganizationBusinessInfoComponent = ({ onInnerFormChange, organization }: any) => (
          <>
<AccordionContainer
    child={
                 <>
                  <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              isDisabled={organization?.BusinessInfo?.Id}
              label="Business Name"
              name="Business Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'BusinessInfo.BusinessName',
                  organization?.BusinessInfo
                )
              }}
              type="text"
              value={organization?.BusinessInfo?.BusinessName}
          />
     <InputContainer
               isDisabled={organization?.BusinessInfo?.Id}
               label="Business PhoneNumber"
               name="Business PhoneNumber"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'BusinessInfo.BusinessPhoneNumber',
                   organization?.BusinessInfo
                 )
               }}
               type="text"
               value={organization?.BusinessInfo?.BusinessPhoneNumber}
           />
     <InputContainer
              isDisabled={organization?.BusinessInfo?.Id}
              label="Stage2 Business Registration Completed"
              name="IsStage2BusinessRegistrationCompleted"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'BusinessInfo.IsStage2BusinessRegistrationCompleted',
                  organization?.BusinessInfo
                )
              }}
              type="checkbox"
              value={organization?.BusinessInfo?.IsStage2BusinessRegistrationCompleted}
          />
      <InputContainer
             isDisabled={organization?.BusinessInfo?.Id}
             label="Stage3 Business Registration Completed"
             name="IsStage3BusinessRegistrationCompleted"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event,
                 'BusinessInfo.IsStage3BusinessRegistrationCompleted',
                 organization?.BusinessInfo
               )
             }}
             type="checkbox"
             value={organization?.BusinessInfo?.IsStage3BusinessRegistrationCompleted}
         />
    </div>
</>
      }
    expandedPanel="Business Info"
    headerTitle="Business Info"
/>
<AccordionContainer
    child={
                 <>
                   <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              isDisabled={organization?.BusinessUserInfo?.Id}
              label="First Name"
              name="First Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'BusinessUserInfo.FirstName',
                  organization?.BusinessUserInfo
                )
              }}
              type="text"
              value={organization?.BusinessUserInfo?.FirstName}
          />
     <InputContainer
               isDisabled={organization?.BusinessUserInfo?.Id}
               label="Last Name"
               name="Last Name"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'BusinessUserInfo.LastName',
                   organization?.BusinessUserInfo
                 )
               }}
               type="text"
               value={organization?.BusinessUserInfo?.LastName}
           />
     <InputContainer
               isDisabled={organization?.BusinessUserInfo?.Id}
               label="Email"
               name="Email"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'BusinessUserInfo.Email',
                   organization?.BusinessUserInfo
                 )
               }}
               type="text"
               value={organization?.BusinessUserInfo?.Email}
           />
     <InputContainer
               isDisabled={organization?.BusinessUserInfo?.Id}
               label="Created On"
               name="Created On"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'BusinessUserInfo.CreatedOnUtc',
                   organization?.BusinessUserInfo
                 )
               }}
               type="date"
               value={organization?.BusinessUserInfo?.CreatedOnUtc}
           />
       <InputContainer
               isDisabled={organization?.BusinessUserInfo?.Id}
               label="Modified On"
               name="Modified On"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'BusinessUserInfo.ModifiedOnUtc',
                   organization?.BusinessUserInfo
                 )
               }}
               type="date"
               value={organization?.BusinessUserInfo?.ModifiedOnUtc}
           />
     </div>
</>
      }
    expandedPanel="Business User Info"
    headerTitle="Business User Info"
/>
<AccordionContainer
    child={
                 <>
                  <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              isDisabled={organization?.SubscriptionInfo?.Id}
              label="Subscription Name"
              name="Subscription Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'SubscriptionInfo.SubscriptionName',
                  organization?.SubscriptionInfo
                )
              }}
              type="text"
              value={organization?.SubscriptionInfo?.SubscriptionName}
          />
     <InputContainer
                isDisabled={organization?.SubscriptionInfo?.Id}
                label="Active"
                name="IsActive"
                onValueChange={(event: any) => {
                  onInnerFormChange(
                    event,
                    'SubscriptionInfo.IsActive',
                    organization?.SubscriptionInfo
                  )
                }}
                type="checkbox"
                value={organization?.SubscriptionInfo?.IsActive}
            />
      <InputContainer
              isDisabled={organization?.SubscriptionInfo?.Id}
              label="Deleted"
              name="IsDeleted"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'SubscriptionInfo.IsDeleted',
                  organization?.SubscriptionInfo
                )
              }}
              type="checkbox"
              value={organization?.SubscriptionInfo?.IsDeleted}
          />
      <InputContainer
              isDisabled={organization?.SubscriptionInfo?.Id}
              label="Subscription Active"
              name="IsSubscriptionActive"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'SubscriptionInfo.IsSubscriptionActive',
                  organization?.SubscriptionInfo
                )
              }}
              type="checkbox"
              value={organization?.SubscriptionInfo?.IsSubscriptionActive}
          />
     <InputContainer
              isDisabled={organization?.SubscriptionInfo?.Id}
              label="Subscription In TrailPeriod"
              name="IsSubscriptionInTrailPeriod"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'SubscriptionInfo.IsSubscriptionInTrailPeriod',
                  organization?.SubscriptionInfo
                )
              }}
              type="checkbox"
              value={organization?.SubscriptionInfo?.IsSubscriptionInTrailPeriod}
          />
      <InputContainer
              isDisabled={organization?.SubscriptionInfo?.Id}
              label="Subscription Paid"
              name="IsSubscriptionPaid"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'SubscriptionInfo.IsSubscriptionPaid',
                  organization?.SubscriptionInfo
                )
              }}
              type="checkbox"
              value={organization?.SubscriptionInfo?.IsSubscriptionPaid}
          />
       <InputContainer
              isDisabled={organization?.SubscriptionInfo?.Id}
              label="Subscription Renewed"
              name="IsSubscriptionRenewed"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'SubscriptionInfo.IsSubscriptionRenewed',
                  organization?.SubscriptionInfo
                )
              }}
              type="checkbox"
              value={organization?.SubscriptionInfo?.IsSubscriptionRenewed}
          />
       <InputContainer
               isDisabled={organization?.SubscriptionInfo?.Id}
               label="Last Subscription Payment Date"
               name="Last Subscription Payment Date"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'SubscriptionInfo.LastSubscriptionPaymentDateonUtc',
                   organization?.SubscriptionInfo
                 )
               }}
               type="date"
               value={organization?.SubscriptionInfo?.LastSubscriptionPaymentDateonUtc}
           />
    <InputContainer
               isDisabled={organization?.SubscriptionInfo?.Id}
               label="Next Subscription Payment Date"
               name="Next Subscription Payment Date"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'SubscriptionInfo.NextSubscriptionPaymentDateonUtc',
                   organization?.SubscriptionInfo
                 )
               }}
               type="date"
               value={organization?.SubscriptionInfo?.NextSubscriptionPaymentDateonUtc}
           />
       <InputContainer
               isDisabled={organization?.SubscriptionInfo?.Id}
               label="Subscription Activation Date"
               name="Subscription Activation Date"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'SubscriptionInfo.SubscriptionActivationDateonUtc',
                   organization?.SubscriptionInfo
                 )
               }}
               type="date"
               value={organization?.SubscriptionInfo?.SubscriptionActivationDateonUtc}
           />
       <InputContainer
               isDisabled={organization?.SubscriptionInfo?.Id}
               label="Subscription Due Date"
               name="Subscription Due Date"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'SubscriptionInfo.SubscriptionDueDateonUtc',
                   organization?.SubscriptionInfo
                 )
               }}
               type="date"
               value={organization?.SubscriptionInfo?.SubscriptionDueDateonUtc}
           />
     <InputContainer
               isDisabled={organization?.SubscriptionInfo?.Id}
               label="Subscription Trail Start Date"
               name="Subscription Trail Start Date"
               onValueChange={(event: any) => {
                 onInnerFormChange(
                   event.target.value,
                   'SubscriptionInfo.SubscriptionTrailStartDateonUtc',
                   organization?.SubscriptionInfo
                 )
               }}
               type="date"
               value={organization?.SubscriptionInfo?.SubscriptionTrailStartDateonUtc}
           />
     </div>
</>
      }
    expandedPanel="Subscription Info"
    headerTitle="Subscription Info"
/>

</>
)
export default OrganizationBusinessInfoComponent;
